<template>
  <div class="contentVideo">
    <video
      ref="video"
      class="video"
      :preload="preload"
      :disablePictureInPicture="true"
      autoplay
      controls
      controlslist="nodownload"
      @pause="handlePause"
      @ended="handleEnd"
    >
      <source :src="videoUrl" type="video/mp4" />
    </video>
  </div>
</template>

<script>
//没有封面，自动播放
// PC端视频组件
export default {
  props: {
    // 视频链接
    url: {
      type: String,
      default: "",
    },
    // 封面链接
    img: {
      type: String,
      default: "",
    },
    // 视频在页面加载时进行加载，并预备播放
    preload: {
      type: String,
      default: "auto",
      validator: function (value) {
        return ["auto", "metadata", "none"].indexOf(value) !== -1;
      },
    },
    // 向用户显示控件
  },
  data() {
    return {
      isImgShow: true, // 显示封面
      videoUrl: this.url,
      videoImg: this.img,
    };
  },
  methods: {
    // 播放
    handlePlay() {
      // 找打所有视频标签，并且暂停
      let videoList = document.getElementsByTagName("video");
      var arr = Array.prototype.slice.call(videoList);
      arr.forEach((item) => {
        item.pause();
      });
      this.isImgShow = false;
      this.$refs.video.play();
    },
    // 视频暂停
    handlePause() {},
    // 视频结束
    handleEnd() {
      console.log("结束");
      this.isImgShow = true;
      this.$refs.video.currentTime = 0;
    },
  },
};
</script>

<style lang="less" scoped>
.contentVideo {
  position: relative;
  width: 100%;
  height: 100%;
  .image {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
  }
  .play {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 10rem;
    height: 10rem;
  }
  .video {
    width: 100%;
    display: block;
  }
}
</style>
